module.exports = __webpack_public_path__ + "img/W-10.a37f9211.jpg";